import { parseBig } from "src/app/core/utils/math-utils";
import {Article} from "./article";
import {PricingItem} from "./pricing-item";

export class ConsumablePricingItem extends PricingItem{

    constructor(public readonly consumable?: Article,
                public readonly consumableExtraPrice?: string,
                public readonly oldConsumableExtraPrice?: string,
                public readonly consoType?: string){
        super();
    }

    hasFranchiseConso(): boolean {
        return parseBig(this.userInputs?.franchiseConso).gt(0);
    }

}
